import { Injectable, Inject } from '@angular/core';
import { TranslateService } from './translate.service';
import { ApiRequestService } from './api-request.service';
import { Observable, ReplaySubject, Subject } from 'rxjs';
import { CommonUtilty } from '../utilities/commonUtility'

@Injectable()
export class ClaimRegistrationService {
    constructor(
        private apiRequest: ApiRequestService,
        private translate: TranslateService,
        private commonUtilty: CommonUtilty
    ) { }
    fetchAPIMetaData(apiName: any): Observable<any> {
        let me = this;

        let APIMetaDataDataSubject = new Subject<any>();

        let pathVariables = [];
        pathVariables.push(apiName);
        this.apiRequest.getCallWithAPIMapper('fetchByAPIName', null, null, pathVariables)
            .subscribe(jsonResp => {
                let returnObj = jsonResp;
                console.log(returnObj);
                APIMetaDataDataSubject.next(returnObj);
            });

        return APIMetaDataDataSubject;
    }

    getClaimDataByGuid(guid: any) {
        let me = this;

        let ClaimDataSubject = new Subject<any>();

        this.apiRequest.get('claim/registration/fetchByGuid/' + guid)
            .subscribe(jsonResp => {
                let returnObj = jsonResp;
                console.log(returnObj);
                ClaimDataSubject.next(returnObj);
            });

        return ClaimDataSubject;
    }

    saveClaimRegistration(body: any): Observable<any> {
        let me = this;

        let claimRegistrationSubject = new Subject<any>();

        this.apiRequest.post('claim/registration/save', body)
            .subscribe(jsonResp => {
                let returnObj = this.commonUtilty.deepCopy(jsonResp);
                console.log(returnObj);
                claimRegistrationSubject.next(returnObj);
            });

        return claimRegistrationSubject;
    }

    submitClaimRegistration(body: any): Observable<any> {
        let me = this;

        let claimRegistrationSubject = new Subject<any>();

        this.apiRequest.post('claim/registration/submit', body)
            .subscribe(jsonResp => {
                let returnObj = this.commonUtilty.deepCopy(jsonResp);
                console.log(returnObj);
                claimRegistrationSubject.next(returnObj);
            });

        return claimRegistrationSubject;
    }


    reopenSubmit(body: any): Observable<any> {
        let me = this;
        let reopenSubject = new Subject<any>();
        this.apiRequest.postCallWithAPIMapper('claimRegistrationReopenClaim', body)
            .subscribe(jsonResp => {
                let returnObj = this.commonUtilty.deepCopy(jsonResp);
                console.log(returnObj);
                reopenSubject.next(returnObj);
            });
        return reopenSubject;
    }

    closeReferelTaskWithRemarks(taskId: any,remarksBy :any) {
        let me = this;

        let ClaimDataSubject = new Subject<any>();

        let pathVariables = [];
        pathVariables.push(taskId || null);
        pathVariables.push(remarksBy || null);

        this.apiRequest.getCallWithAPIMapper('claimWorkFlowCloseTaskWithRemarks', null, null, pathVariables)
        // this.apiRequest.getCallWithAPIMapper('claimWorkFlowCloseTaskWithRemarks/' + taskId + "/" + remarksBy)
            .subscribe(jsonResp => {
                let returnObj = jsonResp;
                console.log(returnObj);
                ClaimDataSubject.next(returnObj);
            });

        return ClaimDataSubject;
    }
    
    saveAdjudication(body: any): Observable<any> {
        let me = this;

        let claimRegistrationSubject = new Subject<any>();

        this.apiRequest.post('claim/adjudication/save', body)
            .subscribe(jsonResp => {
                let returnObj = this.commonUtilty.deepCopy(jsonResp);
                console.log(returnObj);
                claimRegistrationSubject.next(returnObj);
            });

        return claimRegistrationSubject;
    }

    submitAdjudition(body: any): Observable<any> {
        let me = this;

        let claimRegistrationSubject = new Subject<any>();

        this.apiRequest.post('claim/adjudication/submit', body)
            .subscribe(jsonResp => {
                let returnObj = this.commonUtilty.deepCopy(jsonResp);
                console.log(returnObj);
                claimRegistrationSubject.next(returnObj);
            });

        return claimRegistrationSubject;
    }
}